import { Collapse } from 'antd';
import { Button } from 'modules/common/components';
import { FC } from 'react';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PetAccordionTitle } from './PetAccordionTitle';
import styles from './styles.module.scss';

import { PetFormItem } from '../PerFormItem';

type PetAccordionProps = {
  fields: any[];
  activePetIndex: number;
  onPetChange: (index: number) => void;
  onAddPet: () => void;
  onRemovePet: (index: number) => void;
  control: Control<any>;
  sharedRegion?: string;
  sharedLocation?: string;
  isDaycareLocationSelected: boolean;
  microchipPriceText: string;
};

export const PetAccordion: FC<PetAccordionProps> = ({
  fields,
  activePetIndex,
  onPetChange,
  onAddPet,
  onRemovePet,
  control,
  sharedRegion,
  sharedLocation,
  isDaycareLocationSelected,
  microchipPriceText,
}) => {
  const { t } = useTranslation('donor.RegisterPetForm');

  return (
    <>
      <Collapse
        accordion
        activeKey={activePetIndex.toString()}
        onChange={(key) => onPetChange(Number(key))}
      >
        {fields.map((_field, index) => (
          <Collapse.Panel
            key={index.toString()}
            header={
              <PetAccordionTitle
                control={control}
                index={index}
                defaultTitle={`${t('pet')} #${index + 1}`}
              />
            }
            extra={
              index > 0 && (
                <Button
                  size="small"
                  danger
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemovePet(index);
                  }}
                >
                  {t('remove')}
                </Button>
              )
            }
          >
            <PetFormItem
              index={index}
              control={control}
              isFirstPet={index === 0}
              sharedRegion={sharedRegion}
              sharedLocation={sharedLocation}
              microchipPriceText={microchipPriceText}
              isDaycareLocationSelected={isDaycareLocationSelected}
            />
          </Collapse.Panel>
        ))}
      </Collapse>

      {fields.length < 5 && (
        <Button
          type="dashed"
          block
          onClick={onAddPet}
          className={styles.addPetButton}
        >
          {t('addAnotherPet')}
        </Button>
      )}
    </>
  );
};
